<template>
  <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col">
    <form action="#" @submit.prevent="forgotPassword">
      <div class="mb-4">
        <label
          class="block text-grey-darker text-sm font-semibold mb-2"
          for="username"
        >{{ $t('Email') }}</label>
        <input
          class="outline-none appearance-none border rounded w-full py-2 px-3 text-grey-darker focus:border-teal-400"
          id="email"
          type="email"
          placeholder
          v-model="email"
        />
      </div>
      <div class="flex items-center justify-between">
        <button
          class="bg-teal-400 hover:bg-blue-dark text-white font-semibold py-2 px-4 rounded hover:bg-white hover:text-teal-400"
          type="submit"
        >{{ $t('ResetPasswordLink')}}</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      email: ""
    };
  },
  methods: {
    forgotPassword() {
      axios
        .post(`${process.env.VUE_APP_API}/password/email`, {
          email: this.email
        })
        .then(response => console.log(response), this.$router.push("/"))
        .catch(error => console.log(error));
    }
  }
};
</script>

<style>
</style>